import { showErrorToast } from "../../components/toast.component";
import { AppRouteApi } from "../../config/appRoute";
import {
  ApiResponseContainer,
  ApiSchemaAppointmentCheck,
  ApiSchemaFilteredAppointmentCheck,
} from "../../models/api";
import { AxiosAuth } from "../axios";
import { IApiActions } from "./common";

interface IGetByDateRangeParams
  extends IApiActions<ApiSchemaAppointmentCheck[]> {
  data: {
    pageNumber: number;
    pageSize: number;
    nextPageToken?: string;
    startDate: string;
    endDate: string;
    patientId?: string;
    caregiverId?: string;
    companyId: string;
  };
}

async function GetByDateRange({
  onStart,
  onEnd,
  onSuccess,
  onFail,
  data,
}: IGetByDateRangeParams) {
  try {
    onStart?.();
    const response = await AxiosAuth.get<
      ApiResponseContainer<ApiSchemaAppointmentCheck[]>
    >(AppRouteApi.AppointmentCheck.GetByDateRange(), {
      params: data
    });
    onSuccess?.(response.data.data!);
  } catch (error: any) {
    showErrorToast({
      isSuccess: false,
      ...JSON.parse(error.message).data,
    });
    onFail?.();
  } finally {
    onEnd?.();
  }
}

async function GetDetailedActivity({
  onStart,
  onEnd,
  onSuccess,
  onFail,
  data,
}: IGetByDateRangeParams & { onSuccess?: (response: ApiSchemaFilteredAppointmentCheck[]) => void }) {
  try {
    onStart?.();
    const response = await AxiosAuth.get<
      ApiResponseContainer<ApiSchemaFilteredAppointmentCheck[]>
    >(AppRouteApi.AppointmentCheck.GetDetailedActivity(), {
      params: data
    });
    onSuccess?.(response.data.data!);
  } catch (error: any) {
    showErrorToast({
      isSuccess: false,
      ...JSON.parse(error.message).data,
    });
    onFail?.();
  } finally {
    onEnd?.();
  }
}

export const ApiAppointmentCheck = { 
  GetByDateRange,
  GetDetailedActivity 
};
